let routes = [{
		path: '/',
		name: 'layout',
		redirect: {
			name: 'index'
		},
		component: 'layout',
		children: [{
				meta:{title:'後台首頁'},
				component: 'index/index'
			},
			{
				meta:{title:'基礎設置'},
				component: 'set/base/index'
			},
			{
				meta:{title:'學生列表'},
				component: 'data/student'
			},
			{
				meta:{title:'學生名單審核'},
				component: 'data/audit'
			},
			{
				meta:{title:'學生重置密碼申請'},
				component: 'data/editpass'
			},
			{
				meta:{title:'公告列表'},
				component: 'data/notice'
			},
			{
				meta:{title:'比賽列表'},
				component: 'data/competition'
			},
			{
				meta:{title:'收件箱'},
				component: 'data/receiveemail'
			},
			{
				meta:{title:'寄件箱'},
				component: 'data/sendemail'
			},
			{
				meta:{title:'購物車'},
				component: 'data/usercart'
			},
			{
				meta:{title:'訂單記錄'},
				component: 'data/userorder'
			},
			{
				meta:{title:'404错误'},
				component: 'error/404'
			}
			
		]
	},
	{
		// path:'/login',
		// name:'login',
		//component:()=>import('../../views/login/index.vue')
		meta:{title:'登錄页'},
		component: 'login/index'
	},
	{
		path: '*',
		redirect: {
			name: 'index'
		}
	}
]
// 获取路由信息方法
let getRoutes = function() {
	// 生成路由详细信息
	createRoute(routes)
	return routes
}
// 自动生成路由
function createRoute(arr) {
	for (let i = 0; i < arr.length; i++) {
		if (!arr[i].component) return
		// 去除index
		let val = getValue(arr[i].component)
		// 生成name
		arr[i].name = arr[i].name || val.replace(/\//g, '_')
		// 生成apth
		arr[i].path = arr[i].path || `/${val}`
		// 自动生成component
		let componentFun = import(`../../views/${arr[i].component}.vue`)
		arr[i].component = () => componentFun
		if (arr[i].children && arr[i].children.length > 0) {
			createRoute(arr[i].children)
		}
	}
}
// 去除index
function getValue(str) {
	// str = login/index
	// 获取最後一个/索引
	let index = str.lastIndexOf('/')
	// 获取最後一个/後面的值
	let val = str.substring(index + 1, str.length)
	// 判断是不是index结尾
	if (val === 'index') {
		return str.substring(index, -1)
	}
	return str
}
export default getRoutes()
